// 確かめ用の「全解放モード」(2026-11-03 オーナー要望「プレビューははじめからポイントマックスで、全ステージ選べるように」)。
// 次のどちらかで入る:
// - Cloudflare Pages のプレビュー(main 以外の枝)。公開のとき tools/build-site.mjs が <meta name="build-channel" content="preview"> を書く
// - アドレスに ?all を付けて開く(本番・手元でも使える)
// 入ると: DOPA をいつも TEST_DOPA まで補充し、1〜6面を全部選べる。
// 記録は本番とは別の置き場所(senseofdopa.save.test)に書くので、?all で遊んでも本番の記録は変わらない。
// 本番(senseofdopa.pages.dev を ?all なしで開く)は何も変わらない。

export const TEST_DOPA = 999999;

export function isTestMode(doc = globalThis.document, loc = globalThis.location) {
  try {
    if (doc?.querySelector?.('meta[name="build-channel"]')?.content === "preview") return true;
    return new URLSearchParams(loc?.search || "").has("all");
  } catch {
    return false;
  }
}

// 公開のときに書く build-channel の値(Cloudflare Pages の環境変数 CF_PAGES_BRANCH が main 以外ならプレビュー)
export function buildChannel(env = {}) {
  const branch = env.CF_PAGES_BRANCH;
  return branch && branch !== "main" ? "preview" : "production";
}
